/**
 * invoices-api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Information about the entity to whom the invoice is billed.
 */
export interface BillToDto { 
    /**
     * The unique identifier of the user being billed.
     */
    userId?: string;
    name?: string;
    /**
     * Account type of the billed entity.
     */
    accountType?: BillToDto.AccountTypeEnum;
    /**
     * Company name. Only present for BUSINESS accounts.
     */
    companyName?: string | null;
}
export namespace BillToDto {
    export const AccountTypeEnum = {
        Personal: 'PERSONAL',
        Business: 'BUSINESS'
    } as const;
    export type AccountTypeEnum = typeof AccountTypeEnum[keyof typeof AccountTypeEnum];
}


